// extracted by mini-css-extract-plugin
export default {"component":"IncodeStart-module__component-LkvD"};